import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { useLayoutNavigate } from "./useLayoutNavigate";
import { useAppStore } from "../../store";
var isUrl = function isUrl(path) {
  return /^((http|https):\/\/).*/.test(path);
};
export var useProLayoutProps = function useProLayoutProps(props, proLayoutConfig) {
  var _useLayoutNavigate = useLayoutNavigate(),
    navigateByPath = _useLayoutNavigate.navigateByPath;
  // 菜单收缩状态
  var collapsed = useAppStore(function (state) {
    return state.menuCollapsed;
  });
  var flatPathMenus = useAppStore(function (state) {
    return state.flatPathMenus;
  });
  var setMenuCollapsed = useAppStore(function (state) {
    return state.setMenuCollapsed;
  });
  var getMenuProps = function getMenuProps() {
    return _objectSpread(_objectSpread({}, proLayoutConfig === null || proLayoutConfig === void 0 ? void 0 : proLayoutConfig.menuProps), {}, {
      onClick: function onClick(e) {
        var _matchRoute$, _props$layoutConfig$b, _props$layoutConfig;
        var key = e.key === "" ? e.keyPath[1] || "" : e.key;
        var matchRoute = Object.entries(flatPathMenus).find(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            menu = _ref2[1];
          return menu.key === key || menu.path === key;
        });
        var matchPath = (matchRoute === null || matchRoute === void 0 || (_matchRoute$ = matchRoute[1]) === null || _matchRoute$ === void 0 ? void 0 : _matchRoute$.path) || "";
        if (isUrl(key) || isUrl(matchPath)) {
          window.open(key);
          return;
        }
        (_props$layoutConfig$b = (_props$layoutConfig = props.layoutConfig).beforeAddNewTab) === null || _props$layoutConfig$b === void 0 || _props$layoutConfig$b.call(_props$layoutConfig, {
          from: "menu",
          source: matchRoute
        });
        if (matchPath) {
          navigateByPath(matchPath, {
            ignoreSearch: true
          });
        } else {
          console.error("path can't be found", e);
        }
      }
    });
  };
  return _objectSpread(_objectSpread({}, proLayoutConfig), {}, {
    onCollapse: setMenuCollapsed,
    collapsed: collapsed,
    menuProps: getMenuProps(),
    route: props.layoutConfig.route || props.appData.clientRoutes[0]
  });
};